export class Role {
  _id: string;
  type: string;
  name: string;
  description: string;
  permissions: [{
    permissionId: string;
    expiresAt?: Date;
    relatedObjId?: string;
    relatedObjRef?: string;
    relatedObjSection?: string[];
  }];
  updatedAt?: Date;
  createdAt: Date;
}
